export const sessionStorageKeys = {
  subnetWeights: 'subnetWeights',
  tableSorting: 'tableSorting',
};
